import React from 'react';
import './EnrollmentConfirmation.scss';

const EnrollmentConfirmation = ({ agency }) => {
  // Default to "Constellation" if agency is not provided
  const agencyName = agency || "Constellation";
  
  return (
    <div className="enrollment-confirmation-container">
        <div className="check-icon">
            <svg 
                width="64" 
                height="64" 
                viewBox="0 0 32 32" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
    d="M10 14L7 11L5.5 12.5L10 17L20 7L18.5 5.5L10 14Z" 
    fill="#2E7D32"
/>
            </svg>
        </div>
        <div className="enrollment-confirmation-text">
            <h1>Enrollment has been sent.</h1>
            <p>A {agencyName === "Constellation" ? "Customer Success " : ""}representative from {agencyName} will be in touch with you shortly to guide you through the next steps!</p>
        </div>
    </div>
  );
};

export default EnrollmentConfirmation;